import React, { useContext, useState } from 'react'
import { Link, useHistory } from 'react-router-dom';
import { AuthContext } from '../../auth/AuthContext';
import useForm from '../../hooks/useForm'

import apiAuth from '../../services/apis/apiAuth';
import dbConnection from '../../services/utilities/dbConnection';
import { types } from '../../types/types';

import style from '../../assets/styles/auth/authStyle.module.css'
import formStyle from '../../assets/styles/formStyle.module.css'

import imagen from '../../assets/imgs/background/wall.jpg'
import { changeColorCoding } from '../../helpers/db-validators/colorCoding';

const LoginScreen = () => {

    const history = useHistory();
    const { dispatch } = useContext(AuthContext)
    const [mensajeError, setMensajeError] = useState(null);
    
    const { values, handleInputChange } = useForm({
        correo: '',
        password: ''
    });
    const { correo, password } = values;
    
    const handleLogin = async(e) => {
        e.preventDefault();
        
        try {
            const login = await apiAuth.login( values );

            if ( !login.ok ) {
                if ( login.errores ) {
                    changeColorCoding( login.errores )
                } else {
                    setMensajeError( login.msg )
                }
                return;
            }

            
            const { usuario, token } = login.response.data;
            localStorage.setItem('token_organizador', token);
            dbConnection.defaults.headers.common['x-token'] = token;
            dispatch({ type: types.login, payload: usuario});
    
            history.replace(`/organizador/${ usuario._id }`);
            
        } catch (error) {
            setMensajeError( error.response.data.msg )
        }
        
    }

    return (
        <div className={ style.authScreen } >

            <div className={ style.loginScreenBox } >
                <h1> Roof Events </h1>
                <p> ¡Hola de nuevo! Ingresa tus datos para ingresar. </p>
                <form onSubmit={ (e) => e.preventDefault() } className={ formStyle.form + ' mt-1'}>
            
                    <div className={ formStyle.formGroup } >
                        <label
                            htmlFor="correo" > Correo Electrónico</label>
                        <input
                            name='correo'
                            value={ correo }
                            onChange={ handleInputChange }
                            className={ style.input }
                            type="email" />
                        <div data-error='correo' ></div>
                    </div>
                    <div className={ formStyle.formGroup } >
                        <label
                            htmlFor="password" > Contraseña </label>
                        <input
                            name='password'
                            value={ password }
                            onChange={ handleInputChange }
                            type="password"/>
                        <div data-error='password' ></div>
                    </div>
                    <button onClick={ handleLogin } className={ `btn activo bg-primary` } >
                        Ingresar
                    </button>
                    { mensajeError &&
                        <div className='mensajeError'>
                            { mensajeError }
                        </div>
                    }
                </form>
                <p className='text-align-center'>
                    ¿No tienes cuenta?
                    <Link to='/signup'>
                        Crea una en menos de 1 minuto
                    </Link>
                </p>
                <Link to='/forgot'>
                    ¿Olvidaste tu contraseña?
                </Link>
            </div>

            <div className={ style.loginScreenImageSection }>
                <img src={ imagen } alt="" />
            </div>

        </div>
    )
}

export default LoginScreen
